import { __assign } from 'tslib';
import * as React from 'react';

var UitkAlert = function (_a) {
    var AlertTemplateComponent = _a.alertTemplateComponent, alertTemplateData = _a.alertTemplateData;
    return (React.createElement("div", null,
        React.createElement(AlertTemplateComponent, __assign({}, alertTemplateData))));
};

export { UitkAlert };
